// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"60":"c0fa6ee595f20406","144":"e35faad8cb3eef08","408":"b45ef929c111ef76"}[chunkId] + ".js";
};